<template>
  <v-row justify="center">
    <v-dialog
      v-model="versionPaymentDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="versionPaymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>버전별 제공 기능 / 가격 안내</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="versionPaymentDialog = false">닫기</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-row justify="center">
          <v-col>
            <p class="mb-0 display-1 font-weight-black text-center mt-10 mb-3">내 쇼핑몰에 적합한 버전을</p>
            <p class="mb-0 display-1 font-weight-black text-center">선택하여 사용해보세요.</p>
            <!--
            <p class="mb-0 headline font-weight-medium text-center mt-7">
              내 쇼핑몰에 적합한 버전을 선택하여
            </p>
            <p class="mb-0 headline font-weight-medium text-center mb-2">
              사용해보세요.
            </p>
            -->
          </v-col>
        </v-row>

        <v-row justify="center">
          <div class="col-10 justify-center" justify="center">
            <v-row>
              <v-col class="pb-0 pt-10">
                <p class="title font-weight-bold pl-0 ml-0 mb-0">버전별 주요 기능 확인</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-data-table
                    :headers="versionInfoHeaders"
                    :items="versionInfoList"
                    hide-default-footer
                    class="elevation-1"
                  ></v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>

        <v-row justify="center">
          <div class="col-10 justify-center" justify="center">
            <v-row>
              <v-col class="pb-0 pt-10">
                <p class="title font-weight-bold pl-0 ml-0 mb-0">버전별 사용 금액</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-data-table
                    :headers="paymentHeaders"
                    :items="paymentInfoList"
                    hide-default-footer
                    class="elevation-1"
                  ></v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>

        <v-row justify="center">
          <div class="col-10 justify-center" justify="center">
            <v-row>
              <v-col>
                <v-card class="blue lighten-5" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-row class="text-center blue--text mb-4 mt-5">
                        <v-col>달라진 브랜딩 효과를 매출로 경험하세요!</v-col>
                      </v-row>
                      <v-row class="headline text-center font-weight-black pb-0 pt-0">
                        <v-col class="pb-0 pt-0">고객들이 안심하고 구매할 수 있도록</v-col>
                      </v-row>
                      <v-row class="headline text-center font-weight-black">
                        <v-col class="pt-0">정품 인증 서비스를 사용해보세요.</v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <div class="row justify-center mt-0 pt-0 mb-8">
                    <v-btn
                      large
                      color="info"
                      @click="versionPaymentDialog = false"
                      class="saveBtn"
                      style="width:300px"
                    >사용하러 가기</v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  methods: {
    versionPaymentCilck: function() {
      this.versionPaymentDialog = true;
    }
  },
  data() {
    return {
      versionPaymentDialog: false,
      notifications: false,
      sound: true,
      widgets: false,

      versionInfoHeaders: [
        {
          text: "항목",
          align: "center",
          sortable: false,
          value: "category"
        },
        {
          text: "베이직 버전",
          align: "center",
          sortable: false,
          value: "basicVersion"
        },
        {
          text: "플러스 버전",
          align: "center",
          sortable: false,
          value: "plusVersion"
        }
      ],
      versionInfoList: [
        {
          category: "정품 인증 제품 수",
          basicVersion: "무제한",
          plusVersion: "무제한"
        },
        {
          category: "정품 인증 코드 생성",
          basicVersion: "●",
          plusVersion: "●"
        },
        {
          category: "정품 인증 코드 이력 관리",
          basicVersion: "●",
          plusVersion: "●"
        },
        {
          category: "쇼핑몰 정품 인증 페이지",
          basicVersion: "●",
          plusVersion: "●"
        },
        {
          category: "정품 인증 코드 엑셀 다운로드",
          basicVersion: "●",
          plusVersion: "●"
        },
        {
          category: "엑셀 정품 인증 코드 생성",
          basicVersion: "○",
          plusVersion: "●"
        },
        {
          category: "라벨/일반 프린터 인쇄",
          basicVersion: "○",
          plusVersion: "●"
        },
        {
          category: "QR 코드 스캔 정품 인증",
          basicVersion: "○",
          plusVersion: "●"
        },
        {
          category: "분실 제품 이력 관리",
          basicVersion: "○",
          plusVersion: "●"
        },
        {
          category: "분실 제품 SMS 알림 발송",
          basicVersion: "○",
          plusVersion: "●"
        }
      ],

      paymentHeaders: [
        {
          text: "기간",
          align: "center",
          sortable: false,
          value: "days"
        },
        {
          text: "할인율",
          align: "center",
          sortable: false,
          value: "discount"
        },
        {
          text: "베이직 버전",
          align: "center",
          sortable: false,
          value: "basicVersion"
        },
        {
          text: "플러스 버전",
          align: "center",
          sortable: false,
          value: "plusVersion"
        }
      ],
      paymentInfoList: [
        {
          days: "최초 15일",
          discount: "-",
          basicVersion: "무료",
          plusVersion: "무료"
        },
        {
          days: "1개월",
          discount: "-",
          basicVersion: "18,000 (VAT 별도)",
          plusVersion: "29,000 (VAT 별도)"
        },
        {
          days: "3개월",
          discount: "5%",
          basicVersion: "51,300 (VAT 별도)",
          plusVersion: "82,650 (VAT 별도)"
        },
        {
          days: "6개월",
          discount: "10%",
          basicVersion: "97,200 (VAT 별도)",
          plusVersion: "156,600 (VAT 별도)"
        },
        {
          days: "12개월",
          discount: "15%",
          basicVersion: "183,600 (VAT 별도)",
          plusVersion: "295,800 (VAT 별도)"
        }
      ]
    };
  }
};
</script>
